import Vue from 'vue';
export default Vue.extend({
    name: 'buddyDeletePopupChunk',
    methods: {
        onBtnClick() {
            this.$emit('onDelete');
        }
    }
});
